import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"max-width":"720px"}
}
const _hoisted_2 = { class: "card p-4" }
const _hoisted_3 = {
  key: 0,
  class: "mt-3 p-3 rounded bg-body-secondary text-body border"
}

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Admin',
  setup(__props) {

const token = ref(sessionStorage.getItem('adminToken') || '');
const json = ref<string | null>(null);
async function fetchStats() {
  sessionStorage.setItem('adminToken', token.value);
  const res = await fetch('/api/admin/stats', { headers: { 'x-admin-token': token.value }});
  json.value = JSON.stringify(await res.json(), null, 2);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "fw-bold mb-4" }, "Admin", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-3" }, "Enter your admin token to fetch stats.", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((token).value = $event)),
        class: "form-control mb-3",
        type: "password",
        placeholder: "x-admin-token"
      }, null, 512), [
        [_vModelText, token.value]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: fetchStats
      }, "Fetch"),
      (json.value)
        ? (_openBlock(), _createElementBlock("pre", _hoisted_3, _toDisplayString(json.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})